// context/AxiosContext.tsx
import { createContext, useContext } from "react";
import axios, { AxiosInstance } from "axios";
import { useAxios } from "../hooks/useAxios";

const AxiosContext = createContext<AxiosInstance>(axios.create());

const AxiosProvider = ({ clientConfig, children }: { clientConfig: any; children: React.ReactNode }) => {
  // ✅ Created once with correct config, available to ALL children immediately
  const axiosInstance = useAxios(clientConfig);

  return (
    <AxiosContext.Provider value={axiosInstance}>
      {children}
    </AxiosContext.Provider>
  );
};

export const useAxiosClient = () => useContext(AxiosContext);

export { AxiosContext, AxiosProvider };